export default __webpack_public_path__ + "static/media/goog-1.4ebb4645.jfif";